export const styleSheet = theme => ({
    container: {
        cursor: 'pointer',
        fontSize: theme.fonts.fontSizes.size01,
        padding: theme.margins.margin00,
        letterSpacing: '1px',
        textTransform: 'uppercase'
    }
});
